<template>
	<div class="wrap personal-wrap">

	</div>
</template>
<script type="text/javascript">
	import menus from '@components/menus/menus';
	import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
	import empty from '@components/empty/empty';
	export default{
		data () {
			return {
				
		    }
		},
		methods: {
			

		},
		watch: {
		},
		components:{
			menus,
			myOrdersItem,
			empty
		},
	}
</script>
<style lang="scss" rel="stylesheet/scss">
	@import 'personal.scss';
</style>


// WEBPACK FOOTER //
// myaccount.vue?f3f18f4a